import React, { useEffect, useState } from "react";
import { DateRangePicker } from "react-dates";

import IDataFilterDateRangeValue from "./IDataFilterDateRangeValue";

import "react-dates/lib/css/_datepicker.css";
import moment from "moment";

import FormGroup from "features/shared/forms/components/FormGroup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import datePickerStyles from 'features/shared/components/reactDates/dateRangePicker.module.scss';
import styles from "./datafilterdaterangebox.module.scss";

import IDataFilterProps from "../IDataFilterProps";
import { useTranslation } from "react-i18next";
import { getTranslatedFormText } from "features/shared/helpers/translationHelper";

interface IDateState {
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
}

const DataFilterDateRangeBox = (props: IDataFilterProps) => {
  const DATE_FORMAT = "D.M.YYYY";

  // translations
  const tLables = useTranslation("shared\\dataFilters").t;
  const tTerms = useTranslation("shared\\terms").t;

  const [dateState, setDateState] = useState<IDateState>({
    startDate: null,
    endDate: null,
  });

  const [dateFocusedInput, setDateFocusedInput] = useState<
    "startDate" | "endDate" | null
  >(null);

  const setRangeFromFilter = () => {
    const descriptorValue = props.filterDescriptor
      .value as IDataFilterDateRangeValue;

    setDateState({
      startDate: descriptorValue.from
        ? moment(descriptorValue.from, DATE_FORMAT)
        : null,
      endDate: descriptorValue.to
        ? moment(descriptorValue.to, DATE_FORMAT)
        : null,
    });
  };

  const setRangeToFilter = (dateState: IDateState) => {
    const newDescriptors = [...props.descriptors];

    // Získám descriptor
    const descriptor = newDescriptors.find(
      (x) => x.name === props.filterDescriptor.name
    );

    // Nastavím hodnotu
    const rangeValue = descriptor?.value as IDataFilterDateRangeValue;
    if (dateState) {
      rangeValue.from = dateState.startDate
        ? dateState.startDate.format(DATE_FORMAT).toString()
        : "";
      rangeValue.to = dateState.endDate
        ? dateState.endDate.format(DATE_FORMAT).toString()
        : "";
    } else {
      rangeValue.from = "";
      rangeValue.to = "";
    }

    // Update filtru
    props.setDescriptors(newDescriptors);
  };

  const handleOnDatesChange = (dateState: IDateState) => {
    setRangeToFilter(dateState);
    setDateState(dateState);
  };

  useEffect(() => {
    setRangeFromFilter();
  }, []);

  return (
    <FormGroup key={props.reactKey} labelText={getTranslatedFormText(props.filterDescriptor, "label", tLables)}>
      <div className={`${datePickerStyles.customDateRangePicker} ${styles.dateRangePickerFilter}`}>
        <DateRangePicker                
          startDatePlaceholderText={tTerms("From")}
          endDatePlaceholderText={tTerms("To")}
          displayFormat={DATE_FORMAT}
          startDate={dateState.startDate}        
          startDateId={`${props.reactKey}_start_${props.filterDescriptor.name}`}
          endDate={dateState.endDate}
          endDateId={`${props.reactKey}_end_${props.filterDescriptor.name}`}
          numberOfMonths={1}
          minimumNights={0}
          showClearDates={true}
          isOutsideRange={() => false}
          onDatesChange={handleOnDatesChange}
          focusedInput={dateFocusedInput}
          onFocusChange={(focusedInput) => setDateFocusedInput(focusedInput)}
          customInputIcon={<FontAwesomeIcon icon="calendar-alt" size="sm" />}
          block
          hideKeyboardShortcutsPanel
          daySize={32}
        />
      </div>
    </FormGroup>
  );
};

export default DataFilterDateRangeBox;
